"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolbarSeparatorItem = void 0;
var tslib_1 = require("tslib");
var toolbar_item_base_1 = require("./toolbar-item-base");
var separator_toolbar_item_template_creator_1 = require("./toolbar-item-template-creators/separator-toolbar-item-template-creator");
var ToolbarSeparatorItem = (function (_super) {
    tslib_1.__extends(ToolbarSeparatorItem, _super);
    function ToolbarSeparatorItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ToolbarSeparatorItem.prepareElement = function (element) {
        var resolvedElement = element.classList ? element : element[0];
        if (!resolvedElement)
            return;
        var containerElement = resolvedElement.querySelector('.dx-toolbar-item-content');
        if (containerElement)
            containerElement.classList.add(ToolbarSeparatorItem.SeparatorContainerClassName);
    };
    ToolbarSeparatorItem.prototype.getBuildTemplateStrategy = function () {
        return new separator_toolbar_item_template_creator_1.SeparatorToolbarItemTemplateCreator();
    };
    ToolbarSeparatorItem.SeparatorContainerClassName = 'dx-r-separator-container';
    return ToolbarSeparatorItem;
}(toolbar_item_base_1.ToolbarItemBase));
exports.ToolbarSeparatorItem = ToolbarSeparatorItem;
